export const updateTheme = theme => dispatch => {
    dispatch({type: 'UPDATE_THEME', theme: theme});
};